module.exports = __webpack_public_path__ + "img/view.0901b0cc.svg";